import React from 'react';


export default class YearButtons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      year: '',
      yearIndex: ''
    };

    this.handleButtons = this.handleButtons.bind(this);
    this.handleButtonsClick = this.handleButtonsClick.bind(this);
  }

  handleButtonsClick(props) {
    let year = props;
    let index = this.props.data.map(d => { return d.Year }).indexOf(year);
   
    this.setState({
      year: year,
      yearIndex: index,
    });

    this.props.onChange(year, index);
  }

  handleButtons() {
    let buttons = [];
    let selections = [];

    for (let i = this.props.data.length - 1; i >= 0; i--) {
      let data = Object.assign({}, this.props.data[i]);

      for (let m = 0; m < data['Month'].length; m++) {  //** loop into data points /* let j of data['Month'] */
        let j = data['Month'][m];
        if (!isNaN(j)) {  //** if data points not equal NaN, then create buton tag
          let year = data.Year;

          //** create elements for small screen devices
          selections.push(
            <option key={ year } className="selection" value={year}>
              { year }
            </option>
          );
          
          //** create elements for large screen devices
          buttons.push(
            <button key={ year } onClick={() => {this.handleButtonsClick(year)}}
            //  className={i === this.state.yearIndex ? 'clicked buttons' : 'unclick buttons'}
            className={i === this.props.yearSelected[1] ? 'clicked buttons' : 'unclick buttons'}
              >{ year }</button>
          );
          break;
        } 
      }
    };

    return {
      'selections': selections,
      'buttons': buttons,
    };
  }

  render() {
    return(
      <div id="year-controller">
        <h2>資料年份</h2>
        <div id="year-buttons">
          {this.handleButtons()['buttons']}
          
          <select className="selection" onChange={(event) => {this.handleButtonsClick(+event.target.value)}}>
            <option className="selection" defaultValue value="-">-- 請選擇年份 --</option>
            {this.handleButtons()['selections']}
          </select>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/containers/years.js